import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { GlobalPartnerTypes } from '../models/globalPartnerTypes'

export const getGlobalPartnerActualsTypes = (rtm: string): ActualsValueTypes[] => {
  if (rtm === GlobalPartnerTypes.Retailer) {
    return [ActualsValueTypes.Net, ActualsValueTypes.Ndp]
  }
  if (rtm === GlobalPartnerTypes.Distributor) {
    return [ActualsValueTypes.TNet, ActualsValueTypes.Net, ActualsValueTypes.Ndp]
  }
  return [
    ActualsValueTypes.UTNet,
    ActualsValueTypes.TNet,
    ActualsValueTypes.Net,
    ActualsValueTypes.Ndp,
  ]
}

export const getGlobalPartnerDefaultActualsType = (rtm: string): ActualsValueTypes =>
  rtm === GlobalPartnerTypes.Retailer ? ActualsValueTypes.Net : ActualsValueTypes.TNet
